<template>
  <aside
    v-if="isLoggedId"
    class="left-sidebar"
    :class="{'is-closed': !isOpen, 'z-30': isOpenModal}"
  >
    <div ref="navbarHeader" class="navbar-header d-flex align-items-center">
      <a
        href="javascript:void(0)"
        class="nav-link sidebartoggler waves-effect waves-dark pr-1"
        @click.prevent="toggleMenu"
        ><i class="sl-icon-menu ti-menu" style="display: none" />
        <img src="../assets/images/logo.svg" alt="logo" />
      </a>
      <div class="navbar-brand">
        <div>
          <div class="logo_text d-none d-md-block">
            <div class="logo-text">
              <span class="text-green">KYIV</span>
              SP
              <span class="text-blue">О</span>
              <span class="text-light-green">RT</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="scroll-sidebar ps--theme_default"
      data-ps-id="5d3f9084-64f5-3f1e-6e07-ab4b883fdb3e"
    >
      <nav
        class="sidebar-nav active relative"
        :style="{height: navHeight + 'px'}"
      >
        <div
          ref="userProfile"
          class="user-profile"
          :style="{height: userProfileHeight}"
        >
          <span
            aria-expanded="false"
            class="has-arrow waves-dark d-flex align-items-start disabled-link pl-2 cursor-default"
          >
            <router-link
              :to="{name: pathNameUser, params: {id: currentUser.id}}"
              class="user-img"
              :style="{backgroundImage: 'url(' + currentUser.photo + ')'}"
            >
              <span v-if="!currentUser.photo">
                {{ currentUser | fullName | firstLetter }}
              </span>
            </router-link>
            <span class="hide-menu">
              <h3 class="font-weight-bold" style="line-height: normal">
                {{ currentUser | fullName }}
              </h3>
              <span class="user_role d-block">{{ currentUser.role.name }}</span>
            </span>
          </span>
          <span v-if="schoolsList.length" class="select-school">
            <v-select
              class="border-0 select-left-bar"
              :value="school"
              :options="schoolsList"
              :clearable="false"
              :get-option-key="(item) => `${item.name}-${item.id}-${item.type}`"
              label="name"
              @input="changeSchool"
            >
              <template v-slot:open-indicator>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-chevron-down"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
                  />
                </svg>
              </template>
              <template v-slot:no-options="{search, searching}">
                <template v-if="searching">
                  Не знайдено результатів для <em>{{ search }}</em
                  >.
                </template>
                <em v-else>Не знайдено.</em>
              </template>
            </v-select>
          </span>
        </div>
        <ul
          id="sidebarnav"
          class="in overflow-y-auto"
          :style="{height: sidebarnavHeight + 'px'}"
        >
          <li v-for="(item, index) of list" :key="index">
            <router-link
              v-if="
                showLink(item.name) &&
                hidePageGroup(item.name) &&
                hidePageCompetition(item.name) &&
                hidePageTrainings(item.name) &&
                hidePageEnrollment(item.name) &&
                hidePageReporting(item.name) &&
                hidePageCalendarSchool(item.name)
              "
              :to="item.link"
              class="waves-effect waves-dark"
              :exact="item.link === '/'"
            >
              <span class="mr-3 d-inline-block"
                ><img :src="item.imgUrl" :alt="item.name"
              /></span>
              <span class="hide-menu">{{ item.name }}</span>
            </router-link>
          </li>
        </ul>
        <div
          ref="btnExit"
          class="flex justify-center py-3 absolute bottom-5 left-0 right-0 bg-white z-10"
        >
          <button class="green-btn px-4" @click.prevent="openModal">
            вихід
          </button>
        </div>
      </nav>
    </div>
    <logout-modal
      :is-open-modal="isOpenModal"
      @closed="closedModal"
      @submitModal="logout"
    />
  </aside>
</template>

<script>
import {mapGetters, mapState} from 'vuex'
import {mutationTypes} from '@/store/modules/left-sidebar'
import {debounce} from '@/helpers/utils'
import {
  actionType,
  getterTypes as authGetterTypes,
  mutationTypes as mutationsTypesAuth,
} from '@/store/modules/auth'
import {assoc, equals, filter, find, map, propEq, when} from 'ramda'
import LogoutModal from '@/components/modals/LogoutModal'

export default {
  name: 'LeftSidebar',
  components: {LogoutModal},
  data() {
    return {
      isOpenModal: false,
      sidebarnavHeight: null,
      userProfileHeight: null,
      navHeight: null,
      list: [
        {
          name: 'Довідники',
          imgUrl: require('@/assets/images/icon/left_sidebar/icon-info.svg'),
          link: '/directory',
        },
        {
          name: 'Різновиди змагальної діяльності',
          imgUrl: require('@/assets/images/icon/left_sidebar/icon-competitive-activity.svg'),
          link: '/competitive-activity',
        },
        {
          name: 'Види спорту',
          imgUrl: require('@/assets/images/icon/left_sidebar/icon-kinds-sport.svg'),
          link: '/kinds-sport',
        },
        {
          name: 'Спортивні об’єкти',
          imgUrl: require('@/assets/images/icon/left_sidebar/icon-sport-object.svg'),
          link: '/sports-objects',
        },
        {
          name: 'Магазини',
          imgUrl: require('@/assets/images/icon/left_sidebar/icon-faq.svg'),
          link: '/store',
        },
        {
          name: 'Мапа укриттів',
          imgUrl: require('@/assets/images/icon/left_sidebar/icon-faq.svg'),
          link: '/map-shelters',
        },
        {
          name: 'Спортсмени',
          imgUrl: require('@/assets/images/icon/left_sidebar/icon-athletes.svg'),
          link: '/athlete',
        },
        {
          name: 'Користувачі',
          imgUrl: require('@/assets/images/icon/left_sidebar/icon-users.svg'),
          link: '/all-users',
        },
        {
          name: 'Тренери',
          imgUrl: require('@/assets/images/icon/left_sidebar/icon-trainers.svg'),
          link: '/trainers',
        },
        {
          name: 'Групи підготовки',
          imgUrl: require('@/assets/images/icon/left_sidebar/icon-groups.svg'),
          link: '/training-groups',
        },
        {
          name: 'Розклад тренувань',
          imgUrl: require('@/assets/images/icon/left_sidebar/icon-trainints.svg'),
          link: '/trainings-schedule',
        },
        {
          name: 'Спортивні заклади',
          imgUrl: require('@/assets/images/icon/left_sidebar/icon-sport-schools.svg'),
          link: '/sports-schools',
        },
        {
          name: 'Спортивні клуби',
          imgUrl: require('@/assets/images/icon/left_sidebar/icon-sport-object.svg'),
          link: '/sports-clubs',
        },
        {
          name: 'Спортивні федерації',
          imgUrl: require('@/assets/images/icon/left_sidebar/icon-sport-federations.svg'),
          link: '/sports-federations',
        },
        {
          name: 'Спортивні події',
          imgUrl: require('@/assets/images/icon/left_sidebar/icon-sport-events.svg'),
          link: '/sports-events',
        },
        {
          name: 'Список змагань',
          imgUrl: require('@/assets/images/icon/left_sidebar/icon-sport-events.svg'),
          link: '/competitions',
        },
        {
          name: 'Календар подій',
          imgUrl: require('@/assets/images/icon/left_sidebar/icon-calendar-events.svg'),
          link: '/calendar-events',
        },
        {
          name: 'Календар змагань',
          imgUrl: require('@/assets/images/icon/left_sidebar/icon-calendar-events.svg'),
          link: '/calendar-school',
        },
        {
          name: 'FAQ',
          imgUrl: require('@/assets/images/icon/left_sidebar/icon-faq.svg'),
          link: '/faq',
        },
        {
          name: 'Новини',
          imgUrl: require('@/assets/images/icon/left_sidebar/icon-faq.svg'),
          link: '/news',
        },
        {
          name: 'Ролі',
          imgUrl: require('@/assets/images/icon/left_sidebar/icon-roles.svg'),
          link: '/roles',
        },
        {
          name: 'Персонал',
          imgUrl: require('@/assets/images/icon/left_sidebar/icon-personal.svg'),
          link: '/users',
        },
        {
          name: 'Техпідтримка',
          imgUrl: require('@/assets/images/icon/left_sidebar/icon-support.svg'),
          link: '/support',
        },
        {
          name: 'Норми витрат',
          imgUrl: require('@/assets/images/icon/left_sidebar/faq_menu_icon.svg'),
          link: '/tariffs',
        },
        {
          name: 'Аналітика',
          imgUrl: require('@/assets/images/icon/left_sidebar/icon-analytic.svg'),
          link: '/analytics',
        },
        {
          name: "Зворотній зв'язок",
          imgUrl: require('@/assets/images/icon/left_sidebar/icon-email.svg'),
          link: '/feedback',
        },
        {
          name: 'Відгуки(Тренери)',
          imgUrl: require('@/assets/images/icon/left_sidebar/icon-email.svg'),
          link: '/feedback-trainers',
        },
        {
          name: 'Заявка на зарахування',
          imgUrl: require('@/assets/images/icon/left_sidebar/icon-enrollment.svg'),
          link: '/enrollment',
        },
        {
          name: 'Заявки на видалення',
          imgUrl: require('@/assets/images/icon/left_sidebar/icon-enrollment.svg'),
          link: '/removal-requests',
        },
        {
          name: 'Звітність',
          imgUrl: require('@/assets/images/icon/left_sidebar/icon-reporting.svg'),
          link: '/reporting',
        },
        {
          name: 'Журнал дій',
          imgUrl: require('@/assets/images/icon/left_sidebar/actions-log.svg'),
          link: '/actions',
        },
        {
          name: 'Home',
          imgUrl: require('@/assets/images/icon/left_sidebar/pin-copy.svg'),
          link: '/',
        },
      ],
    }
  },
  computed: {
    ...mapState({
      isOpen: (state) => state.leftSidebar.isOpen,
      school: (state) => state.auth.currentSchool,
    }),
    ...mapGetters({
      currentUser: authGetterTypes.currentUser,
      isLoggedId: authGetterTypes.isLoggedId,
      showLink: authGetterTypes.showList,
      currentSchoolId: authGetterTypes.currentSchoolId,
      currentSchoolType: authGetterTypes.currentSchoolType,
    }),
    pathNameUser() {
      return this.currentUser.type === 'trainer' ? 'trainerInfo' : 'userInfo'
    },
    schoolsList() {
      return map(this.editNameAllScool(), this.currentUser.schools)
    },
  },

  watch: {
    currentSchoolId() {
      this.addHeightSideBar()
    },
    currentSchoolType() {
      this.addHeightSideBar()
    },
  },

  created() {
    window.addEventListener('resize', (event) => {
      this.eventHandler(this, event)
      this.addHeightSideBar()
    })
    window.addEventListener('load', (event) => {
      this.eventHandler(this, event)
    })
  },
  destroyed() {
    window.removeEventListener('resize', this.eventHandler)
    window.removeEventListener('load', this.eventHandler)
  },
  mounted() {
    this.addHeightSideBar()
    const schools = filter(
      propEq('type', this.currentSchoolType),
      this.currentUser.schools
    )
    let school = null
    if (this.currentSchoolId !== 'all') {
      school = find(propEq('id', this.currentSchoolId), schools)
    } else {
      school = {
        type: 'all',
        name: 'Департамент молоді та спорту',
      }
    }

    this.$store.commit(mutationsTypesAuth.setCurrentSchool, school)
    this.scrollToElement()
  },
  methods: {
    scrollToElement() {
      const activeNav$ = document.querySelector('a.active')
      if (activeNav$) {
        activeNav$.scrollIntoView()
      }
    },
    editNameAllScool() {
      return when(
        propEq('type', 'all'),
        assoc('name', 'Департамент молоді та спорту')
      )
    },
    addHeightSideBar() {
      this.userProfileHeight = null
      const refs = this.$refs

      setTimeout(() => {
        if (refs.navbarHeader && refs.userProfile && refs.btnExit) {
          const intViewportHeight = window.innerHeight
          const navbarHeaderHeight = refs.navbarHeader.offsetHeight
          const userProfileHeight = refs.userProfile.offsetHeight
          const btnExitHeight = refs.btnExit.offsetHeight

          this.navHeight = intViewportHeight - navbarHeaderHeight

          this.sidebarnavHeight =
            intViewportHeight -
            navbarHeaderHeight -
            userProfileHeight -
            btnExitHeight -
            30

          this.userProfileHeight = userProfileHeight + 'px'
        }
      }, 400)
    },
    hidePageGroup(namePage) {
      return !(
        this.currentSchoolId === 'all' && namePage === 'Групи підготовки'
      )
    },
    hidePageEnrollment(namePage) {
      return !(
        this.currentSchoolId === 'all' && namePage === 'Заявка на зарахування'
      )
    },
    hidePageReporting(namePage) {
      return !(this.currentSchoolId === 'all' && namePage === 'Звітність')
    },
    hidePageCalendarSchool(namePage) {
      return !(
        this.currentSchoolId === 'all' && namePage === 'Календар змагань'
      )
    },
    hidePageTrainings(namePage) {
      return !(
        this.currentSchoolId === 'all' && namePage === 'Розклад тренувань'
      )
    },
    hidePageCompetition(namePage) {
      return !(this.currentSchoolId === 'all' && namePage === 'Список змагань')
    },
    changeSchool(school) {
      const schoolId = school.type === 'all' ? 'all' : school.id
      const schoolType = school.type

      const hasAll = equals('all', schoolId)
      if (hasAll) {
        this.$store
          .dispatch(actionType.setCurrentSchoolId, {
            schoolId: 'all',
            schoolType,
          })
          .then(() => {
            this.$store.commit(mutationsTypesAuth.setCurrentSchool, school)
          })
      } else {
        this.$store
          .dispatch(actionType.setCurrentSchoolId, {
            schoolId,
            schoolType,
          })
          .then(() => {
            this.$store.commit(mutationsTypesAuth.setCurrentSchool, school)
          })
      }
    },
    toggleMenu() {
      if (this.isOpen) {
        this.$store.commit(mutationTypes.closed)
      } else {
        this.$store.commit(mutationTypes.open)
      }
    },
    eventHandler: debounce((vm, event) => {
      const w = event.currentTarget.innerWidth
      if (w >= 1024) {
        vm.$store.commit(mutationTypes.open)
      } else {
        vm.$store.commit(mutationTypes.closed)
      }
    }, 200),
    openModal() {
      this.isOpenModal = true
    },
    closedModal() {
      this.isOpenModal = false
    },
    logout() {
      this.$store.dispatch(actionType.logout).then(() => {
        this.closedModal()
        this.$router.push({name: 'authLogin'})
      })
    },
  },
}
</script>

<style lang="scss">
.left-sidebar {
  &.is-closed {
    width: 70px;
    overflow: hidden;

    a {
      padding: 10px 20px;
    }

    .hide-menu {
      display: none;
    }

    .user-profile {
      margin: 0;

      a {
        padding: 6px;
      }
    }

    .navbar-brand {
      display: none;
    }
  }
}

.scroll-sidebar {
  width: 260px;
}

.disabled-link {
  border: 0 !important;
}

.select-school {
  .vs__selected {
    word-break: break-all;
  }
}

.select-filter {
  .vs__selected {
    text-align: left;
  }
  .vs__selected-options {
    flex-wrap: nowrap;
  }
}
</style>
